module.exports = __webpack_public_path__ + "img/leg-right-front.192e4bb9.png";